import api from './api';

const serviceService = {
  // Récupérer tous les services
  getServices: async (params = {}) => {
    try {
      const response = await api.get('/services', { params });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des services:', error);
      throw error;
    }
  },

  // Récupérer un service par ID
  getService: async (id) => {
    try {
      const response = await api.get(`/services/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération du service:', error);
      throw error;
    }
  },

  // Récupérer les catégories de services actives
  getCategoryServices: async () => {
    try {
      const response = await api.get('/services/categories/active');
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des catégories de services:', error);
      throw error;
    }
  },

  // Rechercher des services
  searchServices: async (query) => {
    try {
      const response = await api.get('/services', {
        params: { search: query }
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la recherche des services:', error);
      throw error;
    }
  }
};

export { serviceService };

